module.exports = __webpack_public_path__ + "static/media/imgAppNotfaund.1b59913a.svg";